import React, { Component } from "react";
import classNames from "classnames";
import { connect } from "react-redux";
import { push } from "react-router-redux";

import InfoPanel from "./InfoPanel";
import LoadingPage from "./LoadingPage";
import LoggedUser from "../components/LoggedUser";
import { logoutAction, getDecodedUser } from "../utils/login";
import PublicLoginDropdown from "./layout/PublicLoginDropdown";

import AppHeader from "./layout/AppHeader";
import TopNav from "./layout/TopNav";
import PageHero from "./layout/PageHero";
import AppFooter from "./layout/AppFooter";
import GoUpButton from "./layout/GoUpButton";

import {
  toggleSidebar,
  togglePanel,
  clearApiError,
} from "../actions/appActions";
import { getNotificationDuration } from "../agenda/Cro/CroActions";
import BannerList from "../agenda/Cro/components/BannerList";

const DEFAULT_PAGE_TITLE = "CRO";

class Sidebar extends Component {
  getPageTitle = () => {
    const { routes } = this.props;
    if (!Array.isArray(routes)) {
      return DEFAULT_PAGE_TITLE;
    }

    // react-router (v2/3) passes matched routes in `routes` array (root -> leaf)
    // We want the deepest matched route that defines a pageTitle.
    for (let i = routes.length - 1; i >= 0; i -= 1) {
      const r = routes[i];
      if (r && r.pageTitle) {
        return r.pageTitle;
      }
    }

    return DEFAULT_PAGE_TITLE;
  };

  syncDocumentTitle = () => {
    const pageTitle = this.getPageTitle();
    document.title = pageTitle ? `${pageTitle} | CRO` : "CRO";
  };
  timeout = {};
  state = {};

  handleClick = (value) => {
    this.setState({ activeItem: null });

    if (value.path !== "/prihlaseni") {
      this.props.push(value.path);
    }
  };

  closeInfoPanel = () => {
    clearTimeout(this.timeout);
    this.props.togglePanel(null);
  };

  closeApiError = () => {
    this.props.clearApiError();
  };

  state = { duration: 5 };

  componentWillReceiveProps(nextProps) {
    const { text } = this.props;
    if (text === null && nextProps.text !== null) {
      this.props.getNotificationDuration().then((seconds) => {
        this.setState({ duration: seconds });
        this.timeout = setTimeout(this.closeInfoPanel, seconds * 1000);
      });
    }
  }

  componentDidMount() {
    this.syncDocumentTitle();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location !== this.props.location) {
      this.syncDocumentTitle();
    }
  }

  render() {
    const {
      items,
      isOpen,
      children,
      router,
      location,
      text,
      isLoading,
      loadingText,
      routes,
      apiError,
    } = this.props;

    const handleNavigate = (value) => {
      this.handleClick(value);
    };

    // Even on public pages we want the global layout (header/nav/footer).
    // Items can be empty (e.g. menu not initialized yet). In that case we still
    // render header + footer, and TopNav will just be empty.
    const safeItems = Array.isArray(items) ? items : [];

    const decodedUser = getDecodedUser();
    const isAuthenticated =
      Array.isArray(decodedUser?.aut) && decodedUser.aut.length > 0;

    const headerRightSlot = isAuthenticated ? (
      <LoggedUser onLogout={logoutAction()} />
    ) : (
      <PublicLoginDropdown items={safeItems} onNavigate={handleNavigate} />
    );

    const currentPath = location?.pathname || "";
    const deepestRoutePath =
      Array.isArray(routes) && routes.length > 0
        ? routes[routes.length - 1]?.path || ""
        : "";
    const isLoginRoute =
      currentPath.startsWith("/prihlaseni/") ||
      deepestRoutePath.startsWith("/prihlaseni/") ||
      currentPath === "/samlsignin" ||
      deepestRoutePath === "/samlsignin";

    return (
      <div
        key="appContainer"
        className={classNames("appContainer", { open: isOpen })}
      >
        {isLoading && <LoadingPage loadingText={loadingText} />}
        <InfoPanel
            text={text}
            onClose={this.closeInfoPanel}
            duration={this.state.duration}
        />
        {apiError?.message && (
          <InfoPanel
            text={
              <span>
                {apiError.message}
                {apiError.detail ? ` (${apiError.detail})` : ""}
                <span
                  style={{
                    display: "block",
                    fontSize: "0.8em",
                    marginTop: 4,
                    opacity: 0.75,
                  }}
                >
                  {apiError.time && <span>Čas: {apiError.time}</span>}
                  {apiError.correlationId && (
                    <span> | CorrelationId: {apiError.correlationId}</span>
                  )}
                  {apiError.nodeId && <span> | NodeId: {apiError.nodeId}</span>}
                </span>
              </span>
            }
            onClose={this.closeApiError}
          />
        )}

        <AppHeader
          rightSlot={headerRightSlot}
          mobileBottomSlot={isAuthenticated ? headerRightSlot : null}
          menuItems={safeItems}
          onNavigate={handleNavigate}
          isAuthenticated={isAuthenticated}
        />
        <TopNav
          items={safeItems}
          router={router}
          location={location}
          onNavigate={handleNavigate}
        />

        <main className="appMain">
          {!isLoginRoute && (
            <PageHero title={this.getPageTitle()} showBack={false} />
          )}
          <div key="agendaContainer" className="agendaContainer">
            <BannerList currentPath={currentPath} menuItems={safeItems} />
            <div key="childs">{children}</div>
          </div>
        </main>

        <AppFooter />
        <GoUpButton />
      </div>
    );
  }
}

const mapStateToProps = (state) => state.sidebar;
export default connect(mapStateToProps, {
  push,
  toggleSidebar,
  togglePanel,
  clearApiError,
  getNotificationDuration,
})(Sidebar);
